import { object, string, TypeOf } from 'yup';

export const ListProjectTemplateFilterSchema = object({
  name: string(),
});

export type ListProjectTemplateFilterType = TypeOf<
  typeof ListProjectTemplateFilterSchema
>;
